import styled from "styled-components";
import { colors } from "../theme";

const Wrap = styled.div<{ color?: "red" | "green" }>`
  text-align: center;
  display: flex;
  justify-content: center;

  color: ${p => (p.color === "red" ? colors.red : colors.bluegrey)};
`;

type Props = {
  className?: string;
  children: any;
  red?: boolean;
};

export default function Message(props: Props) {
  return (
    <Wrap className={props.className} color={props.red ? "red" : "green"}>
      {props.children}
    </Wrap>
  );
}
